window.Drupal.behaviors['searchResults'] = {
    attach(context: Document | HTMLElement) {
        initFacetUrlSelects(context);
    },
};

function initFacetUrlSelects(context: Document | HTMLElement): void {
    context.querySelectorAll<HTMLSelectElement>('[data-facet-url-select]').forEach((select) => {
        select.addEventListener('change', (e) => {
            const url = (e?.target as HTMLSelectElement)?.value;
            if (url) window.location.href = url;
        });
    });
}
